import createReducer from "./createReducer";

import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";

export const GLOBAL_ACTIONS = {
	SEARCH_AJAX: "SEARCH_AJAX",
	SEARCH_SUCCESS: "SEARCH_SUCCESS",
	SEARCH_ERROR: "SEARCH_ERROR",
};

const GLOBAL_ITEMS = {
	assets: {
		url({ libraryId }){ return `ui/creative-libraries/${libraryId}/assets`; },
	},
};

export function search(key, urlParams, queryParams){
	return (dispatch) => {
		let item = GLOBAL_ITEMS[key];
		if(!item){
			return Promise.reject({ success: false });
		}

		let url = (typeof(item.url) === "function") ? item.url(urlParams) : item.url;

		return dispatch({
			type: GLOBAL_ACTIONS.SEARCH_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url,
				params: queryParams,
				success: GLOBAL_ACTIONS.SEARCH_SUCCESS,
				error: GLOBAL_ACTIONS.SEARCH_ERROR,
			},
		});
	};
}

const initialState = {

};

const actionCreators = {
	search,
};

const handlers = {

};

let reducerConfig = {
	typeRoot: "GLOBAL",
	initialState,
	actionTypes: GLOBAL_ACTIONS,
	actionCreators,
	handlers,
};


export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const Global = reducerConfig.actionCreators;
